import { useLocale } from 'state/intl';
import { t } from 'state/intl/translations';
import { ILocalizedMenuEntry } from 'state/unified-menu/types';

const CAL_SUFFIX = 'Cal';

export const useProductCalories = (product: ILocalizedMenuEntry) => {
  const { locale } = useLocale();

  const calSuffix = t('cal') ?? CAL_SUFFIX;
  const localizedCalories = Math.floor(product.nutrition?.calories?.def ?? 0).toLocaleString(
    locale
  );

  return `${localizedCalories} ${calSuffix}`;
};
